export interface DoorbetalingTier {
  totWeek: number | null // inclusief; null = open einde
  pct: number
}

export const DEFAULT_DOORBETALING_TIERS: DoorbetalingTier[] = [
  { totWeek: 52, pct: 100 },
  { totWeek: 104, pct: 90 },
  { totWeek: null, pct: 70 },
]

/** weekNr = 1-gebaseerd aantal weken sinds eerste ziektedag van het (samengetelde) geval. */
export function doorbetalingPctVoorWeek(weekNr: number, tiers = DEFAULT_DOORBETALING_TIERS): number {
  for (const t of tiers) {
    if (t.totWeek === null || weekNr <= t.totWeek) return t.pct
  }
  return tiers[tiers.length - 1]?.pct ?? 0
}

/** dagIndexInGeval = 0-gebaseerde index van de ziektedag binnen het geval (gesorteerd). */
export function isWachtdag(dagIndexInGeval: number, aantalWachtdagen: number): boolean {
  return dagIndexInGeval < aantalWachtdagen
}

/** Normaliseer een Date naar UTC-middernacht (00:00:00.000 UTC). */
function toUtcMidnight(date: Date): number {
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}

/**
 * Helper: weeknr (1-gebaseerd) van een datum binnen een geval dat op startDatum begon.
 *
 * Beide argumenten worden eerst naar UTC-middernacht genormaliseerd, zodat een
 * `startDatum` of `datum` met een tijdcomponent de weekgrens niet kan verschuiven
 * (bv. start 09:00 vs dag 00:00 zou anders een ruwe ms-diff < 7 dagen geven en
 * de medewerker een week te laag inschalen).
 */
export function weekNrInGeval(startDatum: Date, datum: Date): number {
  const dagen = Math.floor((toUtcMidnight(datum) - toUtcMidnight(startDatum)) / (24 * 60 * 60 * 1000))
  return Math.floor(Math.max(0, dagen) / 7) + 1
}
